import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PanToolIcon(props: IconProps) {
    return <Icon {...props} iconKey={"pan_tool"}/>
}
